"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPropsByRate = void 0;
var _ramda = require("ramda");
var _localization = _interopRequireDefault(require("../../../../../../../../localization"));
var _high = _interopRequireDefault(require("./img/high.svg"));
var _low = _interopRequireDefault(require("./img/low.svg"));
var _constants = require("./constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var getPropsByRate = exports.getPropsByRate = (0, _ramda.cond)([[(0, _ramda.equals)(_constants.RATES_OF_CONFIRMATION.HIGH), (0, _ramda.always)({
  icon: _high.default,
  get text() {
    return _localization.default.t('OFFER_DETAILS:HIGH_RATE_OF_CONFIRMATION_TITLE');
  },
  get description() {
    return _localization.default.t('OFFER_DETAILS:HIGH_RATE_OF_CONFIRMATION_DESC');
  }
})], [(0, _ramda.equals)(_constants.RATES_OF_CONFIRMATION.LOW), (0, _ramda.always)({
  icon: _low.default,
  get text() {
    return _localization.default.t('OFFER_DETAILS:LOW_RATE_OF_CONFIRMATION_TITLE');
  },
  get description() {
    return _localization.default.t('OFFER_DETAILS:LOW_RATE_OF_CONFIRMATION_DESC');
  }
})], [_ramda.T, (0, _ramda.always)({})]]);